import { Link, useLocation, useNavigate } from 'react-router-dom';
import { openGuideVideo } from '../../libs/guideVideo';
import { isMobile, openPlans } from '../../libs/platform';

function SideBar({ user, setUser }: any) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = (uris: string[]) => uris.includes(pathname);

  function resetSession() {
    const payload = { token: null };
    setUser(payload);
    localStorage.setItem('user', JSON.stringify(payload));
  }

  function handlePlansClick() {
    openPlans(navigate);
  }

  function logoff() {
    if (!window.confirm('Tem certeza que deseja sair do ATARIC?')) return;
    resetSession();
    navigate('/');
  }

  function openWhatsApp() {
    window.open('https://wa.me/554391832935?text=Olá! Preciso de ajuda com o ATARIC.', '_blank');
  }

  const isChat = pathname === '/chat';

  const navItems = [
    { to: '/', icon: 'fa-house', active: isActive(['/']) },
    { action: openGuideVideo, icon: 'fa-play', title: 'Vídeo: Como falar com o Ataric' },
    { to: '/mapas-mentais', icon: 'fa-map', title: 'Mapas mentais · Inglês', active: isActive(['/mapas-mentais']) },
    ...(!isMobile ? [{ to: '/planos', icon: 'fa-crown', active: isActive(['/planos']) } as const] : [{ action: handlePlansClick, icon: 'fa-crown' } as const]),
    { to: '/perfil', icon: 'fa-user-gear', active: isActive(['/perfil']) },
  ];

  return (
    <>
      <nav className="App-side-bar">
        {navItems.map((item, idx) => {
          const iconEl = (
            <div
              key={idx}
              className={`Sidebar-icon-wrap${item.active ? ' Sidebar-icon-wrap--active' : ''}`}
            >
              <i className={`fa-solid ${item.icon}`} />
            </div>
          );

          if (item.to) {
            return <Link key={idx} to={item.to}>{iconEl}</Link>;
          }

          return (
            <button
              key={idx}
              type="button"
              className="App-side-bar-icon"
              onClick={item.action}
              title={item.title}
            >
              {iconEl}
            </button>
          );
        })}
        <button
          type="button"
          className="App-side-bar-icon"
          onClick={logoff}
          title="Sair"
        >
          <div className="Sidebar-icon-wrap">
            <i className="fa-solid fa-right-from-bracket" />
          </div>
        </button>
      </nav>
      {!isChat && (
        <div className="App-whatsapp-button" onClick={openWhatsApp}>
          <i className="fa-brands fa-whatsapp"></i>
        </div>
      )}
    </>
  );
}

export default SideBar;
